import { AgGridReact, AgGridColumn } from "ag-grid-react";
import React, { Component } from "react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const countries = [
	{
		value: "0",
		label: "Global"
	},
	{
		value: "1",
		label: "Argentina"
	},
	{
		value: "2",
		label: "Chile"
	},
	{
		value: "3",
		label: "Uruguay"
	},
	{
		value: "4",
		label: "Paraguay"
	},
	{
		value: "5",
		label: "Argentina y Chile"
	},
	{
		value: "6",
		label: "Argentina y Uruguay"
	},
	{
		value: "7",
		label: "Argentina y Paraguay"
	},
	{
		value: "8",
		label: "Argentina, Chile y Uruguay"
	},
	{
		value: "9",
		label: "Argentina, Chile y Paraguay"
	},
	{
		value: "10",
		label: "Argentina, Uruguay y Paraguay"
	},
	{
		value: "11",
		label: "Chile y Uruguay"
	},
	{
		value: "12",
		label: "Chile y Paraguay"
	},
	{
		value: "13",
		label: "Chile, Uruguay y Paraguay"
	},
	{
		value: "14",
		label: "Uruguay y Paraguay"
	}
];
    
const categorias = [
	{
		value: "1",
		label: "Soliqua"
	},
	{
		value: "2",
		label: "Toujeo"
	},
	{
		value: "3",
		label: "Perfil de Pacientes"
	}
];

  
const gametypes = [
	{
		value: "1",
		label: "Pregunta/Respuesta"
	},
	{
		value: "2",
		label: "Conectar"
	},
	{
		value: "3",
		label: "Afirmación"
	},
	{
		value: "4",
		label: "Vacunas"
	}
];

const vacunas = [
	{
		value: "Menactra",
		label: "Menactra"
	},
	{
		value: "Istivac4",
		label: "Istivac4"
	},
	{
		value: "Adacel",
		label: "Adacel"
	},
	{
		value: "Hexaxim",
		label: "Hexaxim"
	},
	{
		value: "BCG",
		label: "BCG"
	},
	{
		value: "Hepatitis B",
		label: "Hepatitis B"
	},
	{
		value: "Neumococica Conjugada",
		label: "Neumococica Conjugada"
	},
	{
		value: "Pentavalente",
		label: "Pentavalente"
	},
	{
		value: "Polio IPV",
		label: "Polio IPV"
	},
	{
		value: "Rotavirus",
		label: "Rotavirus"
	},
	{
		value: "Meningococo",
		label: "Meningococo"
	},
	{
		value: "Antigripal",
		label: "Antigripal"
	},
	{
		value: "Hepatitis A",
		label: "Hepatitis A"
	},
	{
		value: "Triple Viral SRP",
		label: "Triple Viral SRP"
	},
	{
		value: "Varicela",
		label: "Varicela"
	},
	{
		value: "Triple Bacteriana Celular DTP",
		label: "Triple Bacteriana Celular DTP"
	},
	{
		value: "Triple Bacteriana Acelular",
		label: "Triple Bacteriana Acelular"
	},
	{
		value: "Virus Papiloma Humano VPH",
		label: "Virus Papiloma Humano VPH"
	},
	{
		value: "Doble Bacteriana dT",
		label: "Doble Bacteriana dT"
	},
	{
		value: "Fiebre Amarilla",
		label: "Fiebre Amarilla"
	},
	{
		value: "Fiebre Hemorrogica Argentina",
		label: "Fiebre Hemorrogica Argentina"
	},
	{
		value: "Hexavalente",
		label: "Hexavalente"
	},
	{
		value: "Anti Influenza",
		label: "Anti Influenza"
	},
	{
		value: "Cuadruple",
		label: "Cuadruple"
	},
	{
		value: "Neumococo Polisacarida",
		label: "Neumococo Polisacarida"
	},
	{
		value: "Doble Viral",
		label: "Doble Viral"
	},
	{
		value: "Pentaxim",
		label: "Pentaxim"
	},
	{
		value: "Vaxigrip Tetra",
		label: "Vaxigrip Tetra"
	}
];

const gruposetarios = [
	{
		value: "Recien Nacido",
		label: "Recien Nacido - 1 mes"
	},
	{
		value: "2, 4 y 6 meses",
		label: "2, 4 y 6 meses"
	},
	{
		value: "9 meses",
		label: "9-12 meses"
	},
	{
		value: "12 Meses",
		label: "15-35 Meses"
	},
	{
		value: "15-18 meses",
		label: "3 a 10 años"
	},
	{
		value: "3 a 10 años",
		label: "Adolescentes"
	},
	{
		value: "Adolecente",
		label: "Embarazos"
	},
	{
		value: "Embarazadas",
		label: "Adultos"
	},
	{
		value: "Adultos",
		label: "Personal de Salud"
	}
];


class Questions extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			questionData: 
			{
				idcategory: "",
				idlevel: "",
				idlevelcategory:"",
				country: 0,
				gametype: 0,
				totalTime: 60,
				plusTime: 0,
				answercountry1: 0,
				answercountry2: 0,
				answercountry3: 0,
				answercountry4: 0
			},
			levels: [],
			levelcategories: [],
			rowSelected: false,
			selectedQuestion: null
		};
    }


	handleCreateQuestion = () => {
		this.resetAll();
		this.setState({
			createNew: true
		});
    };
    
	handleCancel = () => {
		this.setState({
			createNew: false, 
			edit: false
		});
	};
	
	onRowSelected = event => {
		console.log(event);
		
		if (event.node.selected) {
			console.log(event.data);
			if(event.data.answercountry1==null)
				event.data.answercountry1 = 0;
			if(event.data.answercountry2==null)
				event.data.answercountry2 = 0;
			if(event.data.answercountry3==null)
				event.data.answercountry3 = 0;
			if(event.data.answercountry4==null)
				event.data.answercountry4 = 0;
			if(event.data.option1left==null)
				event.data.option1left="";
			if(event.data.option1right==null)
				event.data.option1right="";
			if(event.data.option2left==null)
				event.data.option2left="";
			if(event.data.option2right==null)
				event.data.option2right="";
			if(event.data.option3left==null)
				event.data.option3left="";
			if(event.data.option3right==null)
				event.data.option3right="";
			if(event.data.option4left==null)
				event.data.option4left="";
			if(event.data.option4right==null)
				event.data.option4right="";
			this.setState({
				rowSelected: true, 
				selectedQuestion: event.data.idquestion,
				questionData: event.data
				});
			this.props.loadLevels(this.state.questionData.idcategory);
			this.props.loadLevelCategories(this.state.questionData.idlevel);

		}else{
			if(this.state.selectedQuestion == event.data.idquestion)
			{
			this.setState({
				rowSelected: false,
				selectedQuestion: null,
				questionData: null
				});
			}
		}
	  };

	onEdit = () =>{
		

		this.setState({
			edit: true
		});
	}

	handleSaveEdit = () => {
		if(this.checkComplete)
		{
			if(this.state.questionData.gametype == 1 ||this.state.questionData.gametype == 3 )
			{
				this.props.handleUpdateQuestion({
					"idquestion":this.state.questionData.idquestion,
					"category":this.state.questionData.category,
					"level":this.state.questionData.level,
					"idlevelcategory":this.state.questionData.idlevelcategory,
					"country":this.state.questionData.country,
					"gametype":this.state.questionData.gametype,
					"question":this.state.questionData.question,
					"answer1":this.state.questionData.answer1,
					"answer2":this.state.questionData.answer2,
					"answer3":this.state.questionData.answer3,
					"answer4":this.state.questionData.answer4,
					"iscorrect1":this.state.questionData.iscorrect1 ? 1 : 0,
					"iscorrect2":this.state.questionData.iscorrect2 ? 1 : 0,
					"iscorrect3":this.state.questionData.iscorrect3? 1 : 0,
					"iscorrect4":this.state.questionData.iscorrect4? 1 : 0
				});
			}
			else if(this.state.questionData.gametype == 2  ||this.state.questionData.gametype == 4)
				{
					this.props.handleUpdateQuestionConnect({
							"gametype":this.state.questionData.gametype,
							"idquestion":this.state.questionData.idquestion,
							"category":this.state.questionData.category,
							"level":this.state.questionData.level,
							"idlevelcategory":this.state.questionData.idlevelcategory,
							"country":this.state.questionData.country,
							"question":this.state.questionData.question,
							"option1left":this.state.questionData.option1left,
							"option1right":this.state.questionData.option1right,
							"option2left":this.state.questionData.option2left,
							"option2right":this.state.questionData.option2right,
							"option3left":this.state.questionData.option3left,
							"option3right":this.state.questionData.option3right,
							"option4left":this.state.questionData.option4left,
							"option4right":this.state.questionData.option4right,
							"totalTime":this.state.questionData.totalTime,
							"plusTime":this.state.questionData.plusTime,
							"answercountry1":this.state.questionData.answercountry1,
							"answercountry2":this.state.questionData.answercountry2,
							"answercountry3":this.state.questionData.answercountry3,
							"answercountry4":this.state.questionData.answercountry4
						});
				}
				console.log(this.state.questionData.answercountry1);
				console.log(this.state.questionData.answercountry2);
				console.log(this.state.questionData.answercountry3);
				console.log(this.state.questionData.answercountry4);
				this.resetAll();
				this.handleCancel();
		}

	}

	handleDelete = () => {
		this.props.deleteQuestion(this.state.questionData.idquestion);
		this.setState({
			deleteModal:false
		});
	}


    handleConfirm = () => {
		if(this.checkComplete)
		{
			if(this.state.questionData.gametype == 1 ||this.state.questionData.gametype == 3 )
			{
			
				this.props.handleSaveQuestion({
					"category":this.state.questionData.category,
					"level":this.state.questionData.level,
					"idlevelcategory":this.state.questionData.idlevelcategory,
					"country":this.state.questionData.country,
					"gametype":this.state.questionData.gametype,
					"question":this.state.questionData.question,
					"answer1":this.state.questionData.answer1,
					"answer2":this.state.questionData.answer2,
					"answer3":this.state.questionData.answer3,
					"answer4":this.state.questionData.answer4,
					"iscorrect1":this.state.questionData.iscorrect1 ? 1 : 0,
					"iscorrect2":this.state.questionData.iscorrect2 ? 1 : 0,
					"iscorrect3":this.state.questionData.iscorrect3? 1 : 0,
					"iscorrect4":this.state.questionData.iscorrect4? 1 : 0
				});
			}
			else if(this.state.questionData.gametype == 2 ||this.state.questionData.gametype == 4 )
				{
					this.props.handleSaveQuestionConnect({
							"gametype":this.state.questionData.gametype,
							"idquestion":this.state.questionData.idquestion,
							"category":this.state.questionData.category,
							"level":this.state.questionData.level,
							"idlevelcategory":this.state.questionData.idlevelcategory,
							"country":this.state.questionData.country,
							"question":this.state.questionData.question,
							"option1left":this.state.questionData.option1left,
							"option1right":this.state.questionData.option1right,
							"option2left":this.state.questionData.option2left,
							"option2right":this.state.questionData.option2right,
							"option3left":this.state.questionData.option3left,
							"option3right":this.state.questionData.option3right,
							"option4left":this.state.questionData.option4left,
							"option4right":this.state.questionData.option4right,
							"totalTime":this.state.questionData.totalTime,
							"plusTime":this.state.questionData.plusTime,
							"answercountry1":this.state.questionData.answercountry1,
							"answercountry2":this.state.questionData.answercountry2,
							"answercountry3":this.state.questionData.answercountry3,
							"answercountry4":this.state.questionData.answercountry4
						});
				}
			this.resetAll();
			this.handleCancel();
		}
		
		
	}

	resetAll = () => {
		this.setState({questionData : {
            createNew: false,
            category: "",
            level: "",
            idlevelcategory:"",
			question:"",
			country: 0,
			gametype: 0,
			totalTime: 0,
			plusTime: 0,
            answer1:"",
            answer2:"",
            answer3:"",
			answer4:"",
			option1left:"",
			option1right:"",
			option2left:"",
			option2right:"",
			option3left:"",
			option3right:"",
			option4left:"",
			option4right:"",
            iscorrect1: false,
            iscorrect2: false, 
            iscorrect3: false,
			iscorrect4 : false,
			answercountry1:0,
            answercountry2:0,
            answercountry3:0,
			answercountry4:0
		}});
	}
	
	checkComplete = () =>{
		if(this.state.gametype == 0 ||this.state.gametype == 2 )
		{
			if(this.state.questionData.category &&
			this.state.questionData.level &&
			this.state.questionData.idlevelcategory &&
			this.state.questionData.question &&
			this.state.questionData.answer1 &&
			this.state.questionData.answer2)
				return true;
		}else if(this.state.gametype == 1)
		{
			if(this.state.questionData.category &&
				this.state.questionData.level &&
				this.state.questionData.idlevelcategory &&
				this.state.questionData.question &&
				this.state.questionData.option1left &&
				this.state.questionData.option1right &&
				this.state.questionData.option2left &&
				this.state.questionData.option2right)
				return true;
		}else if(this.state.gametype == 4)
		{
			if(this.state.questionData.category &&
				this.state.questionData.level &&
				this.state.questionData.idlevelcategory &&
				this.state.questionData.question &&
				this.state.questionData.option1left &&
				this.state.questionData.option1right)
				return true;
		}

		return false;
	}
    

    
	componentDidMount() {}

	render() {
		return (
			<React.Fragment>
			{ this.state.deleteModal ? 
            <Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.deleteModal}
				>
					<Paper
						style={{
							display: "grid",
							width: "500px",
							padding: "25px",
                            margin: "20% auto",
                            height: "200px",
                            overflowY: "auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
						<br />
						<br />
							<b>Seguro desea borrar? </b>
							<br /><br /><br />
                    
								<Button
								onClick={this.handleDelete}
								type="submit"
								color="primary"
								variant="contained"
							>
								Borrar
							</Button>
						
							
							&nbsp;&nbsp;&nbsp;
							<Button onClick={()=>{this.setState({deleteModal:false})}} color="primary">
								Cancelar
							</Button>
						
						</div>
					</Paper>
				</Modal>
				: null }



			{ this.state.questionData !== null || this.state.createNew ? 
            <Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.createNew || this.state.edit}
				>
					<Paper
						style={{
							display: "grid",
							width: "70%",
							padding: "25px",
                            margin: "auto auto",
                            height: "90%",
                            overflowY: "auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Pregunta
							<br />
                            <TextField
								id="standard-select"
								select
								label="Tipo Juego"
								style={{
                                 
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.questionData.gametype}
								onChange={value =>{
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , gametype: value.target.value }}});
                                    }
								}
							>
								{gametypes.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
                            <TextField
								id="standard-select"
								select
								label="Categoría"
								style={{
                                 
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.questionData.idcategory}
								onChange={value =>{
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , idcategory: value.target.value }}});
                                    this.props.loadLevels(value.target.value);
                                    }
								}
							>
								{categorias.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
                            
                            <TextField
								id="standard-select"
								select
								label="Nivel"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.questionData.idlevel}
								onChange={value => {
									
									this.props.loadLevelCategories(value.target.value);
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , idlevel: value.target.value }}});
                                }
                            }
							>
								{this.props.levels.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
                            <br />
                            <TextField
								id="standard-select"
								select
								label="Sub-Categoría"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.questionData.idlevelcategory}
								onChange={value =>
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , idlevelcategory: value.target.value }}})

								}
							>
								{this.props.levelCategories ?
								this.props.levelCategories.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								)):null}
							</TextField>
							<br />
                            <TextField
								id="standard-select"
								select
								label="Pais"
								style={{
                                 
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.questionData.country}
								onChange={value =>{
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , country: value.target.value }}});
                                    }
								}
							>
								{countries.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
							<br />
							<br />
							<TextField
								id="outlined-basic"
								label="Pregunta"
                                variant="outlined"
                                multiline
								value={this.state.questionData.question}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , question: value.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
							{
								this.state.questionData.gametype == 1 || this.state.questionData.gametype == 3 ?
							(
							<React.Fragment>
                            <br />
							<TextField
								id="outlined-basic"
								label="Respuesta 1"
								variant="outlined"
								multiline
								value={this.state.questionData.answer1}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answer1: value.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={(this.state.questionData.iscorrect1==true)}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , iscorrect1: event.target.checked }}})
									}}
                                    label="Es Correcta?" 
                                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							
                            <TextField
								id="outlined-basic"
								label="Respuesta 2"
								variant="outlined"
								multiline
								value={this.state.questionData.answer2}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answer2: value.target.value }}});
								}}
								style={{ width: "90%", textAlign: "left" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
									checked={(this.state.questionData.iscorrect2==true)}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , iscorrect2: event.target.checked }}});
									}}
	                                    label="Es Correcta?" inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} 
                                    />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							<TextField
								id="outlined-basic"
								label="Respuesta 3"
								variant="outlined"
								multiline
								value={this.state.questionData.answer3}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answer3: value.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                        <Checkbox 
                                        checked={(this.state.questionData.iscorrect3==true)}
										onChange={event =>{
											event.persist();
											this.setState(prevState =>{return {questionData:{ ...prevState.questionData , iscorrect3: event.target.checked }}});
										}}
											label="Es Correcta?" 
                                        inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
                            <TextField
								id="outlined-basic"
								label="Respuesta 4"
								variant="outlined"
								multiline
								value={this.state.questionData.answer4}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answer4: value.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={(this.state.questionData.iscorrect4==true)}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , iscorrect4: event.target.checked }}})
									}}
								label="Es Correcta?" 
                                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							</React.Fragment>
							):null}
							{
								this.state.questionData.gametype == 2 ? 
								(
									<React.Fragment>
									<br />		
										<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 1</div>
										<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.questionData.option1left}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option1left: event.target.value }}});
								}}
							style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.questionData.option1right}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option1right: event.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />	
								<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 2</div>
								<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.questionData.option2left}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option2left: event.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.questionData.option2right}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option2right: event.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
							<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 3</div>
								<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.questionData.option3left}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option3left: event.target.value }}});
								}	}			
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.questionData.option3right}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option3right: event.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />
							<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 4</div>
								<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.questionData.option4left}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option4left: event.target.value }}});
								}}								
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.questionData.option4right}
								onChange={event =>{
									event.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option4right: event.target.value }}});
								}}			
								style={{ width: "90%" }}
							/>
							<br /><br />

									</React.Fragment>
								):null
							}
							{
							this.state.questionData.gametype == 4 ?
							(
								<React.Fragment>
									<br />
								<TextField
								id="outlined-basic"
								label="Tiempo Total"
								variant="outlined"
								multiline
								value={this.state.questionData.totalTime}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , totalTime: value.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br /><br />
							<TextField
								id="outlined-basic"
								label="Tiempo Bonificación"
								variant="outlined"
								multiline
								value={this.state.questionData.plusTime}
								onChange={value =>{
									value.persist();
									this.setState(prevState =>{return {questionData:{ ...prevState.questionData , plusTime: value.target.value }}});
								}}
								style={{ width: "90%" }}
							/>
							<br />		
									<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción Correcta 1</div>
									<TextField
									id="outlined-basic"
									label="Vacuna"
									variant="outlined"
									select
									value={this.state.questionData.option1left}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option1left: event.target.value }}});
									}}
									style={{ width: "90%" }}
									>   {vacunas.map(option => (
										<MenuItem key={option.value} value={option.value}>
										{option.label}
										</MenuItem>
									))}
									</TextField>
									<br /><br />
								<TextField
									id="outlined-basic"
									label="Grupo Etario"
									variant="outlined"
									select
									value={this.state.questionData.option1right}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option1right: event.target.value }}});
									}}
									style={{ width: "90%" }}
								>   {gruposetarios.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Pais"
									variant="outlined"
									select
									value={this.state.questionData.answercountry1}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answercountry1: event.target.value }}});
									}}			
									style={{ width: "90%" }}
								> {countries.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br />	
									<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción Correcta 2 (Opcional)</div>
									<TextField
									id="outlined-basic"
									label="Vacuna"
									variant="outlined"
									select
									value={this.state.questionData.option2left}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option2left: event.target.value }}});
									}}
									style={{ width: "90%" }}
									> {vacunas.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
									))}
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Grupo Etario"
									variant="outlined"
									select
									value={this.state.questionData.option2right}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option2right: event.target.value }}});
									}}
									style={{ width: "90%" }}
								> {gruposetarios.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}			
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Pais"
									variant="outlined"
									select
									value={this.state.questionData.answercountry2}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answercountry2: event.target.value }}});
									}}			
									style={{ width: "90%" }}
								> {countries.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br />
								<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción Correcta 3 (Opcional)</div>
									<TextField
									id="outlined-basic"
									label="Vacuna"
									variant="outlined"
									select
									value={this.state.questionData.option3left}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option3left: event.target.value }}});
									}	}			
									style={{ width: "90%" }}
								> {vacunas.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
									))}
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Grupo Etario"
									variant="outlined"
									select
									value={this.state.questionData.option3right}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option3right: event.target.value }}});
									}}
									style={{ width: "90%" }}
								> {gruposetarios.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Pais"
									variant="outlined"
									select
									value={this.state.questionData.answercountry3}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answercountry3: event.target.value }}});
									}}			
									style={{ width: "90%" }}
								> {countries.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br />
								<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción Correcta 4 (Opcional)</div>
									<TextField
									id="outlined-basic"
									label="Vacuna"
									variant="outlined"
									select
									value={this.state.questionData.option4left}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option4left: event.target.value }}});
									}}								
									style={{ width: "90%" }}
								> {vacunas.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
									))}
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Grupo Etario"
									variant="outlined"
									select
									value={this.state.questionData.option4right}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , option4right: event.target.value }}});
									}}			
									style={{ width: "90%" }}
								> {gruposetarios.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br /><br />
								<TextField
									id="outlined-basic"
									label="Pais"
									variant="outlined"
									select
									value={this.state.questionData.answercountry4}
									onChange={event =>{
										event.persist();
										this.setState(prevState =>{return {questionData:{ ...prevState.questionData , answercountry4: event.target.value }}});
									}}			
									style={{ width: "90%" }}
								> {countries.map(option => (
									<MenuItem key={option.value} value={option.value}>
									{option.label}
									</MenuItem>
								))}
								</TextField>
								<br /><br />
								</React.Fragment>
							):null}

							{
								this.state.edit ? 
								<Button
								onClick={this.handleSaveEdit}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Guardar
							</Button>
								: 
								<Button
								onClick={this.handleConfirm}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Agregar
							</Button>
							}
							
							&nbsp;&nbsp;&nbsp;
							<Button onClick={this.handleCancel} color="primary">
								Cancelar
							</Button>
						
						</div>
					</Paper>
				</Modal>
				: null }

				<h2 style={{ width: "100%", textAlign: "left" }}>Preguntas</h2>
                <div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreateQuestion}
						color="primary"
						variant="contained"
					>
						Agregar Pregunta
					</Button>
					{" "}
					{( this.state.rowSelected ? 
					<React.Fragment>
					<Button
						onClick={this.onEdit}
						color="primary"
						variant="contained"
					>
						Editar
					</Button>
					{" "}
					<Button
						onClick={()=>{this.setState({deleteModal: true})}}
						color="primary"
						variant="contained"
					>
						Borrar
					</Button>
					</React.Fragment>
					: null)}
				</div>

				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "100%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.questions}
						rowSelection="single"
						onRowSelected={this.onRowSelected}

					>    
					  <AgGridColumn
					headerName="#"
					width={40}
					checkboxSelection
					suppressSorting
					suppressMenu
					suppressFilter
					pinned
					/>
					<AgGridColumn headerName="Id" field="idquestion" width={60} />
					<AgGridColumn headerName="Categoria" field="categoryname" width={100} />
					<AgGridColumn headerName="Nivel" field="levelname" width={100} />
					<AgGridColumn headerName="Pais" field="displaycountry" width={100} />
					<AgGridColumn
					headerName="Subcategoria"
					field="idlevelcategoryname"
					width={100}
					/>
					<AgGridColumn
					headerName="Pregunta"
					field="question"
					width={200}
					/>
					<AgGridColumn headerName="Respuesta 1" field="answer1" width={200} />
					<AgGridColumn headerName="Respuesta 2" field="answer2" width={200} />
					<AgGridColumn headerName="Respuesta 3" field="answer3" width={200} />
					<AgGridColumn headerName="Respuesta 4" field="answer4" width={200} />

					</AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Questions;
